import { IModelDataV1, IModelDataV3WithUrl, Model, TLoadDependeciesParams } from '@df/catalog/model';
import last from 'lodash-es/last';

export interface IRouteData extends IModelDataV1<string> {
    target?: number | string;
    targetType?: string;
    rewrite?: string;
}

export class Route extends Model<IRouteData, string> {
    /**
     * Object type id
     * @type {String}
     */
    static override type = 'route';

    /**
     * Max verbosity
     * @type {String}
     */
    override maxVerbosity = 1;

    protected override addDependenciesToLoader(params: TLoadDependeciesParams): Promise<any> | void {
        super.addDependenciesToLoader(params);
        if (this.data && !this.target && !this.data.rewrite && this.id.length > 1 && last(this.id) === '/') {
            this.data.rewrite = this.id.slice(0, -1);
        }
        const target = this.target;
        if (target) {
            params.loader.add(target.load(3, params));
        }
    }

    /**
     * Sends load request to API which resolves with model data
     */
    protected override async loadModelFromApi(verbosity: number): Promise<void> {
        const routeData = await this.requestService.route({ path: this.id, pushDeps: true });
        this.setData({ ...(routeData as IRouteData), verbosity: 1 });
    }

    /**
     * Target model getter
     *
     * usage:
     *
     * route.target
     *
     */
    public get target(): Model<IModelDataV3WithUrl> | undefined {
        if (this.data?.targetType && this.data.target) {
            const resource = this.resources[this.data.targetType];

            if (resource) {
                return <Model<IModelDataV3WithUrl>>resource.getCreate(this.data.target);
            }
        }
        return undefined;
    }
}
